<template>
  <bottom-bar-layout class="page-training-level-detail"
                     :show-bar="showTaskBtn"
                     :bar-height="160"
                     :shadow="false"
                     bar-background="transparent"
                     :is-show-guide-popup="false"
  >
    <detail-content :levelData="levelData"
                    v-if="levelData"
                    @changeData="handleChangeType"
    />
    <template #tabbar>
      <div class="training-submit-btn-container task-btn">
        <ym-button class="training-submit-btn"
                   :class="[
                   render.isFinish ? 'training-submit-btn-light' : 'training-submit-btn-primary'
                   ]"
                   size="large"
                   @click="handleClickBtn"
        >
          {{ buttonText }}
        </ym-button>
      </div>
    </template>
  </bottom-bar-layout>
</template>

<script>
  import { Button } from '@ymba/ym-ui';
  import { mapGetters } from 'vuex';
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import { getTrainingLevelDetail } from '@/services/training';
  import DetailContent from '@/pages/TrainingLevel/components/LevelDetailContent';

  export default {
    name: 'PageTrainingLevelDetail',
    metaInfo() {
      return {
        title: this.title,
      };
    },
    components: {
      BottomBarLayout,
      DetailContent,
      'ym-button': Button,
    },
    data() {
      return {
        type: 'english',
        chineseData: null,
        englishData: null,
        render: {
          isFinish: false,
        },
        training: {
          id: 0,
        },
        levelId: 0,
        task: {
          id: 0,
        },
      };
    },
    computed: {
      ...mapGetters([
        'player',
      ]),
      showTaskBtn() {
        return this.levelId > 0 && this.type === 'english';
      },
      levelData() {
        return this.type === 'chinese' ? this.chineseData : this.englishData;
      },
      title() {
        return this.levelData ? this.levelData.level.title : '';
      },
      buttonText() {
        return this.render.isFinish ? '我的打卡日历' : '打卡任务';
      },
    },
    watch: {
      type() {
        this.player.pause();
      },
    },
    methods: {
      fetchData(levelId) {
        this.getEnglishLevelDetail(levelId);
        this.getChineseLevelDetail(levelId);
      },
      async getEnglishLevelDetail(id) {
        const data = await getTrainingLevelDetail(id, 'english');
        this.englishData = data;
        this.render = data.render;
        this.levelId = data.level.id;
        this.task = data.task;
        this.training = data.training;
        // 添加返回路径
        this.$route.meta.back = { name: 'TrainingDetail', params: { id: data.training.id } };
      },
      async getChineseLevelDetail(id) {
        this.chineseData = await getTrainingLevelDetail(id, 'chinese');
      },
      handleChangeType(type) {
        this.type = type;
      },
      handleClickBtn() {
        const route = this.render.isFinish
          ? { name: 'TrainingDetail', params: { id: this.training.id } }
          : { name: 'TrainingTaskDetail', params: { id: this.task.id } };
        this.$router.push(route);
      },
    },
    created() {
      const levelId = this.$route.params.id;
      this.fetchData(levelId);
    },
    beforeRouteUpdate(to, from, next) {
      const levelId = to.params.id;
      this.fetchData(levelId);
      next();
    },
    beforeRouteLeave(to, from, next) {
      this.player.pause();
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-training-level-detail {
    background: @color-white;
  }

  .task-btn {
    padding: @size-base;
  }

</style>
